<template>
<!-- <v-row v-if="lastrowdot" no-gutters class="flex-nowrap">

  <last-row :meta="meta" v-model="lastrow"></last-row>

</v-row> -->
<!-- <v-container v-if="lastrowdot" no-gutters fluid class="pa-0"> 

  <last-row :meta="meta" v-model="lastrow"></last-row>

</v-container> -->

<v-row no-gutters class="flex-nowrap">

<!--dialogextra columns-->
  <v-col v-if="colextra==true" cols-12 md-6 style="min-width: 300px; max-width: 350px">

      <v-btn
      v-if = "printfiltered==true" 
      variant="outlined"
        class="mb-1 mr-1"
        color="regular" 
        @click="printIt()"> <svg-icon type="mdi" :path="mdiPrinter"/> <span class="d-none d-sm-none d-md-flex">Print filtered</span> 
      </v-btn>


<div class="d-flex justify-between">
  <v-btn
    class="mr-1 d-flex d-sm-none d-none d-sm-flex d-md-none px-2"
    variant="flat"
    color="accent"
    @click="getData(), colextra=!colextra">
    Apply and close filter
  </v-btn>
</div>
<div class="position-relative rounded-0 overflow-y-auto">
  <div class="pe-3">
        <base-filter 
          v-for="col in meta.columns" 
          :key='col'
          :column='col'
          :meta='meta'
          v-model="filters[col.fieldname]"
          @update:modelValue="page=1, lastrowdot=false, getData()"
          > 
        </base-filter>
        
      </div>
    </div>



  </v-col>

  <!--end of first column-->
  <v-col cols-12 md-6>
    <!-- <v-container ma-0 pa-0 style= "background: red;"  > -->
<!-- <div v-for="col in meta.columns" :key="col">
  <div v-if="meta.title.includes('species') || meta.description.includes('Single_species')">
    <species-separate-filter
    v-if="col.fieldname == 'species'" 
                            :key='col'
                            :column='col'
                            :meta='meta'
                            v-model="filters[col.fieldname]"
                            @update:modelValue="getData"
    >
    </species-separate-filter>
  </div>
</div> -->

<geospatial-filter-separate
  v-if="geofilterson==true"
  :column='meta.columns'
  :meta='meta'
  :pointfieldname='this.pointfieldname'
  :url = 'this.url'
  v-model="filters[this.pointfieldname]"
  @filterupdate="page=1, getData()" 
></geospatial-filter-separate>

        

        <span v-if="allCookies.username">
          <v-btn class="mb-1 mr-1"  color="accent" v-if="curentRow.id" @click="dialogedrow=!dialogedrow, actionedit = true, actionclone = false, actionadd = false ">
            <svg-icon type="mdi" :path="mdiSquareEditOutline"/>  <span class="d-none d-sm-none d-md-flex">Edit</span>
          </v-btn>
          <span v-if="addeditclone==false"> 
            <v-btn class="mb-1 mr-1"  color="regularlight" v-if="curentRow.id" @click="dialogedrow = !dialogedrow, initRow('clone'), actionclone = true, actionedit = false, actionadd = false">
              <svg-icon type="mdi" :path="mdiContentCopy"/>  <span class="d-none d-sm-none d-md-flex">Clone</span>
            </v-btn>
            <v-btn class="mb-1 mr-1"  color="regular" @click="dialogedrow=!dialogedrow, initRow('add'), actionadd = true,  actionclone = false, actionedit = false">
              <svg-icon type="mdi" :path="mdiPlus"/>  <span class="d-none d-sm-none d-md-flex">Add</span>
            </v-btn>
            &nbsp;&nbsp;&nbsp;
          </span>
          <!-- <v-btn class="mb-1 mr-1"  color="vs" v-if="curentRow.id" @click="updateData('delete'), curentRow={}">
            <svg-icon type="mdi" :path="mdiDeleteForever"/>  <span class="d-none d-sm-none d-md-flex">Delete</span> 
          </v-btn> -->
          <span>  </span>
        </span>



<!--start filters buttons-->
<v-btn
  v-if="colextra==true"
  variant="flat"
  color = "regular"
  class="mb-1 mr-1" 
  @click="colextra=!colextra"

>
  <svg-icon  type="mdi" :path="mdiFilterRemove"/> <span class="d-none d-sm-none d-md-flex">Hide Filters</span> 
</v-btn>
<v-btn
  v-if="colextra==false"
  variant="flat"
  color = "regular"
  class="mb-1 mr-1" 
  @click="colextra=!colextra"

>
  <svg-icon  type="mdi" :path="mdiFilter"/> <span class="d-none d-sm-none d-md-flex">Show Filters</span> 
</v-btn>


<geo-aerial-filter-vue
  v-if="geofilterson"
  :column='meta.columns'
  :meta='meta'
  v-model="filters[this.pointfieldname]"
  @filterupdate="getData" 
>
</geo-aerial-filter-vue>
<v-btn
v-if="geofilterson"
  class="mb-1 mr-1"
  variant="flat"
  color="regular"
  @click="this.$store.commit('drawEnableDisable')"
>
<svg-icon type="mdi" :path="mdiShapePolygonPlus"/> <span class="d-none d-sm-none d-md-flex">Polygon</span> <svg-icon type="mdi" :path="mdiFilter"/>
</v-btn>
<v-btn
  v-if="geofilterson == false"
  class="mb-1 mr-1" 
  variant="flat"
  color="regular"
  @click = "geofilterson = !geofilterson"
>
<svg-icon type="mdi" :path="mdiEarth"/><span class="d-none d-sm-none d-md-flex">Show Map</span>
</v-btn>
<v-btn
  v-if="geofilterson == true"
  class="mb-1 mr-1" 
  variant="flat"
  color="regular"
  @click = "geofilterson = !geofilterson"
  
>
<svg-icon type="mdi" :path="mdiEarthRemove"/> <span class="d-none d-sm-none d-md-flex">Hide Map</span>  
</v-btn>

<!-- <v-btn class="mb-1 mr-1" variant="outlined" color = "regular" @click="printfiltered=true">
  <svg-icon type="mdi" :path="mdiFilter"/> <span class="d-none d-sm-none d-md-flex">Filter and Print</span> <svg-icon type="mdi" :path="mdiPrinter"/>
</v-btn> -->

<v-btn variant="outlined" class="mb-1 mr-1" v-if="curentRow.id" color="regular" @click="selectedRowsToStore()">
  <svg-icon type="mdi" :path="mdiPrinter"/><span class="d-none d-sm-none d-md-flex">Print selected</span>
</v-btn>

<v-btn variant="flat" class="mb-1 mr-1" color="regular" @click="resetFilters(), printfiltered=false">
  <svg-icon type="mdi" :path="mdiFilterOff"/><span class="d-none d-sm-none d-md-flex">Reset filters</span>
</v-btn>

<!--end filters-->

      <v-table>
        <thead>
            <tr>
              <td v-if="meta.dataset_id === 2017"> LinkTo </td> <!-- open after fix in taxon pages-->
                  <th v-for="col in meta.columns" :key="col">
                <div class="d-flex flex-row">
                  <v-sheet>
                    <v-tooltip activator="parent" location="bottom">Sort</v-tooltip>
                    <svg-icon v-if="sorts[col.fieldname] == false" @click="changeSort(col.fieldname)" type="mdi" :path="mdiSort"/>
                    <svg-icon v-if="sorts[col.fieldname] == true" @click="changeSort(col.fieldname)" color="regular" type="mdi" :path="mdiSortAscending"/>
                    <svg-icon v-if="sorts[col.fieldname] == undefined" @click="changeSort(col.fieldname)" color="accent" type="mdi" :path="mdiSortDescending"/>
                  </v-sheet>
                  <v-sheet class="px-2">
                    {{col.title}} 
                  </v-sheet>
                  <v-sheet>
                    <v-tooltip activator="parent" location="bottom">Group</v-tooltip>              
                    <svg-icon v-if="groupings[col.fieldname] == '' " @click="groupingswitch=!groupingswitch, changeGrouping(col.fieldname)" type="mdi" :path="mdiFormatListGroup"/>
                    <svg-icon v-if="groupings[col.fieldname] == 'groupby' " @click="groupingswitch=!groupingswitch, changeGrouping(col.fieldname)" color="regular" type="mdi" :path="mdiFormatColumns"/>
                    <!--надо как-то обнулять сортинг перед групингом - иначе если сначала сделать сортинг а потом группинг - получится дичь-->
                  </v-sheet>
                </div>
              </th>
          </tr> 
        </thead>
          <!--что такое @getrow ????-->
  
        <data-table :meta="meta" @getrow = "setcurentRow" v-model="rows" :lastrowd="lastrowd" :lastrowdot="lastrowdot"></data-table>

      </v-table>
    <!-- </v-container> -->
    <v-row class="d-flex text-center" align="center">
      <v-col cols="2">
        <v-btn class="mb-1 mr-1" variant="flat" color="regular" @click="dialogexport=!dialogexport">
          <svg-icon type="mdi" :path="mdiFileDownload"/>  <span class="d-none d-sm-none d-md-flex">Download {{ rowscount }} rows</span>
        </v-btn>
      </v-col>
            <v-col cols="4">

            <v-pagination
            v-model="page"
            :length="pagecount"
            @update:modelValue="paginate"

        ></v-pagination> 
        </v-col>

        <v-col cols="2">
        <v-select
        :items="perpageitems"
        label="Per page"
        variant="solo"
        @update:modelValue="perpageupdate"
        ></v-select>
        </v-col>
    </v-row>

  </v-col>
</v-row>



<!--dialogs:-->
<v-dialog
  v-model="toolsfiltersprint"
  temporary
  fullscreen
  max-width="600"
> 

<div class="d-flex justify-between bg-surface-light">
      <v-btn
          class="my-1 ml-1 mr-1"
          variant="flat"
          color="regularlight"
          @click.stop="toolsfiltersprint = !toolsfiltersprint">
          Close
      </v-btn>
      <v-btn 
        class="my-1 mr-1"
        color="regular" 
        @click="printIt()"> <svg-icon type="mdi" :path="mdiPrinter"/> <span class="d-none d-sm-none d-md-flex">Print</span> 
      </v-btn> 
</div>
<div class="bg-surface-light position-relative rounded-0 overflow-y-auto py-1 ps-1">
      <div class="pe-3">
        <base-filter 
          v-for="col in meta.columns" 
          :key='col'
          :column='col'
          :meta='meta'
          v-model="filters[col.fieldname]"
          @update:modelValue="getData"
          > 
        </base-filter>
      </div>
  </div>
</v-dialog>

<v-dialog
  v-model="toolsfilters"
  temporary
  fullscreen
  max-width="600"
> 
<div class="d-flex justify-between bg-surface-light">
  <v-btn
    class="my-1 ml-1 mr-1"
    variant="flat"
    color="regularlight"
    @click.stop="toolsfilters = !toolsfilters">
    Close
  </v-btn>
  <v-btn
    class="my-1 mr-1 d-flex d-sm-none d-none d-sm-flex d-md-none px-2"
    variant="flat"
    color="accent"
    @click="getData(), toolsfilters = !toolsfilters">
    Apply
  </v-btn>
</div>
<div class="bg-surface-light position-relative rounded-0 overflow-y-auto py-1 ps-1">
  <div class="pe-3">
        <base-filter 
          v-for="col in meta.columns" 
          :key='col'
          :column='col'
          :meta='meta'
          v-model="filters[col.fieldname]"
          @update:modelValue="getData"
          > 
        </base-filter>
        
      </div>
    </div>
</v-dialog>




    <v-dialog
        v-model="dialogexport"
        >
        <v-card class="mx-auto rounded-0">

                <v-card-actions  class="d-inline">
                    <v-btn
                        class="my-1"
                        variant="outlined"
                        color="regular"
                        @click.stop="(dialogexport = !dialogexport)">
                        Cancel
                    </v-btn>
                    <v-btn
                        class="my-1"
                        variant="flat"
                        color="regular"
                        @click="getExportData"
                        @click.stop="(dialogexport = !dialogexport)">
                        Download csv
                    </v-btn>
                    <!-- <v-btn
                        class="my-1"
                        variant="flat"
                        color="regular"
                        @click="getExportData">
                        Download txt
                    </v-btn>
                    <v-btn
                        class="my-1"
                        variant="flat"
                        color="regular"
                        @click="getExportData">
                        Download xls
                    </v-btn> -->
                </v-card-actions>
            </v-card>
        </v-dialog>


    
<v-dialog 
fullscreen
v-model="dialogedrow"
>
<v-form>
  <v-card class="rounded-0 px-1">
    <v-card-text>
  <!-- <base-form v-bind="{meta:meta, rowobject:curentRow}" ></base-form> -->
   <base-form-t v-bind="{mode:'edit', meta:allmeta, curentRow:curentRow}" v-model="curentRow"></base-form-t>

<div class="d-flex justify-space-between">
      <!-- <v-btn 
      class="my-1"
      variant="flat"
      color="vs"
      @click="dialogedrow = !dialogedrow,  updateData('delete')" 
      size="x-large"
      >Delete
      </v-btn> -->
      <v-btn 
      v-if="actionedit"
      class="my-1"
      variant="flat"
      color="vs"
      @click="dialogdelete = !dialogdelete" 
      size="x-large"
      >Delete
      </v-btn>


      <v-btn 
      class="my-1"
      variant="outlined"
      color="regular"
      @click="dialogedrow = !dialogedrow, actionedit = false, actionclone = false, actionadd = false"
      size="x-large"
      >Exit
      </v-btn>

      <v-btn 
      v-if="actionedit == true && actionclone == false && actionadd == false"
      class="my-1"
      variant="flat"
      color="attention"
      @click="dialogedrow = !dialogedrow,  updateData('edit'), actionedit = false, actionclone = false, actionadd = false, getLastRowData()"
      size="x-large"
      >Edit
      </v-btn>
      <v-btn 
      v-if="actionclone == true && actionedit == false && actionadd == false"
      class="my-1"
      variant="flat"
      color="attention"
      @click="dialogedrow = !dialogedrow,  updateData('clone'), actionclone = false, actionedit = false, actionadd = false, getLastRowData()"
      size="x-large"
      >Clone
      </v-btn>
      <v-btn 
      v-if="actionadd == true && actionedit == false && actionclone == false"
      class="my-1"
      variant="flat"
      color="attention"
      @click="dialogedrow = !dialogedrow,  updateData('add'), actionadd = false, actionedit = false, actionclone = false, getLastRowData()"
      size="x-large"
      >Add
      </v-btn>

</div> 
</v-card-text>     
  </v-card>
  </v-form>
</v-dialog>
<!--delete dialog start-->
<v-dialog 
v-model="dialogdelete"
>
  <v-card>
    <v-card-text>

  <v-alert
    title="Are you sure you want to delete this? This operation cannot be undone."
    type="warning"
  ></v-alert>
      

  <div class="d-flex flex-column">
      <v-btn 
      class="mt-4"
      variant="flat"
      color="regular"
      @click="dialogdelete = !dialogdelete"
      size="x-large"
      >Cancel
      </v-btn>
      <v-btn 
      class="mt-4"
      variant="flat"
      color="red"
      @click="dialogedrow = !dialogedrow, actionedit = false, actionclone = false, actionadd = false, dialogdelete = !dialogdelete, updateData('delete'), lastrowdot = false" 
      size="x-large"
      >Delete
      </v-btn>
</div>
</v-card-text>     
  </v-card>

</v-dialog>
<!--delete dialog end-->

</template>



<script>
import { defineComponent } from 'vue';
import axios from 'axios';
//import "leaflet/dist/leaflet.css";
//import "leaflet/dist/leaflet-src.esm"
import BaseFilter from '@/components/BaseFilter.vue';
import GeospatialFilterSeparate from './GeospatialFilterSeparate.vue';
import ImageGallery from './ImageGallery.vue';
import BaseTableTools from '@/components/BaseTableTools.vue';
import BaseAdminTableTools from '@/components/BaseAdminTableTools.vue';
import GeoAerialFilterVue from '@/components/GeoAerialFilter.vue';
import SpeciesSeparateFilter from './SpeciesSeparateFilter.vue';

import DataTable from '@/components/DataTable.vue';
//import LastRow from '@/components/LastRow.vue';
import {fieldcalc} from '../plugins/fieldcalc.js';
//import BaseForm from '@/components/BaseForm.vue';
import BaseFormT from '@/components/BaseFormT.vue';

import SvgIcon from '@jamescoyle/vue-icon';
import { mdiPlus, mdiSquareEditOutline, mdiContentCopy, mdiDeleteForever, mdiShapePolygonPlus, mdiEarth, mdiFilter, mdiFilterRemove, mdiEarthRemove, mdiPrinter, mdiFilterOff, mdiSort, mdiSortAscending, mdiSortDescending, mdiFormatListGroup, mdiFormatColumns, mdiFileDownload } from '@mdi/js';

export default defineComponent({
    name: 'base-geo-table',
    components: {
      SvgIcon,
//LastRow,
      DataTable,
//    LMap,
//    LWmsTileLayer,
//    LMarker,
//    LTileLayer,
//    LControlLayers,
    BaseFilter,
    GeospatialFilterSeparate,
    ImageGallery,
    BaseTableTools,
    BaseAdminTableTools,
    GeoAerialFilterVue,
    SpeciesSeparateFilter,
//    BaseForm,
    BaseFormT,
//    VueCookies,
//    calculatefields,
//BaseSort,
//BaseGeneralisation,



  },

    data(){ 
        return {
          mdiPlus: mdiPlus,
          mdiSquareEditOutline:mdiSquareEditOutline,
          mdiContentCopy:mdiContentCopy,
          mdiDeleteForever:mdiDeleteForever,
          mdiShapePolygonPlus:mdiShapePolygonPlus,
          mdiEarth:mdiEarth,
          mdiFilter:mdiFilter,
          mdiFilterRemove:mdiFilterRemove,
          mdiEarthRemove:mdiEarthRemove,
          mdiPrinter:mdiPrinter,
          mdiFilterOff:mdiFilterOff,
          mdiSort:mdiSort,
          mdiSortAscending:mdiSortAscending,
          mdiSortDescending:mdiSortDescending,
          mdiFormatListGroup:mdiFormatListGroup,
          mdiFormatColumns:mdiFormatColumns,
          mdiFileDownload:mdiFileDownload,

          allCookies: '',
          toolsfilters: null,
          toolsfiltersprint: false,
          toolsgeneralisation: null,
// потом в компонет тулсы перенести и через пинию все нагородить
dialogexport: false,
            page:1,
            perPage:10,
            meta:{columns:[]},
            allmeta:{columns:[]},
            rows:[],
            printallrows: [],
            pagecount:0,
            curentRow:{},
            //lastrow:{},
            //lastrow:'',
            lastrowd: {},
            lastrowdot: false,
            perpageitems: ['3', '10', '20', '30'],
            clicktooltip: 'Click to copy',
            url: '',
            pointfieldname: '',
            filters: {},
            filterstoprint: {},
            edited: {},
            sorts: {},
            groupings: {},
            groupingswitch: false,
           groupingitems: ['', 'count', 'groupby'],
// try count rows:
rowscount: '',
geofilterson: false,
format: 'csv',
dialogrow: false,
dialogedrow: false,
dialogaddrow: false,
menu: false,
column: '',
actionedit: false,
actionclone: false,
actionadd: false,
dialogdelete: false,
addeditclone: false,

colextra: true,
printfiltered: false,

}
    },
    
    props:['dataset_uri', 'tablestructur'],


    mounted(){
        this.getMeta();
        let cookieUserData = (decodeURIComponent($store.state.cookies).match('(^|; )' + decodeURIComponent('userData') + '=([^;]+)') || []).pop() || null;
        if (cookieUserData !== null) { 
          this.allCookies = JSON.parse(cookieUserData);
        }
        else {
          this.allCookies = '';
        }

    },


    methods: {

selectedRowsToStore() {
// print by pages
  this.$store.commit('getRowsToPrint', [this.curentRow]);
  this.$store.commit('getMetaPrint', this.allmeta);
  // this.$store.commit('getColumnPrint', this.column);

  // console.log('column',this.meta);

  this.$router.push('/print')
},


// оба метода надо переписать используя async\await
printIt(){
  this.getAllData();
  this.directSelectedRowsToStore();
},

filterstate(){
  this.filterson = true;
},


getAllData() {

//  console.log(this.filters)

  let querydata = {sort: []};
          Object.keys(this.filters).forEach(key => {
          querydata['f_'+key] = this.filters[key];
          if (key in this.sorts && this.sorts[key] != '') {
            querydata.sort.push({fieldname:key, dir: this.sorts[key]});
          }

          if (this.groupingswitch == true) {
            querydata['g_'+key]='count'; // fieldname or key?
            if (key in this.groupings && this.groupings[key] != '') {
              querydata['g_'+key] = this.groupings[key];
            }
            else{
              querydata['g_'+key]='';
            }
          }
          });

        axios
        //  .post(this.dataset_uri+'&unique=undefined&count_rows=true&iDisplayStart='+(this.page-1)*this.perPage+'&iDisplayLength='+this.perPage, querydata)

        .post(this.dataset_uri+'&unique=undefined&count_rows=true&iDisplayStart=0&iDisplayLength='+500, querydata)
        //надо оставить ограничение. Чтобы не выводить 100500 строк если квсе начнут жать принт без фильтров. Вряд ли кто-то печаает этикетки больше чем 500 за раз
 
        .then((response) => {

   //       console.log(response.data.aaData);

  //          this.printallrows=response.data.aaData; // поччему-то так не срабатывает - надо напрямую записывать ответ в стор

            this.$store.commit('getRowsToPrint', response.data.aaData);
          //  this.$store.commit('getMetaPrint', this.allmeta);
//console.log('allmeta',this.allmeta);

              })
              .catch(error => console.log(error));
},


directSelectedRowsToStore() {
  this.$router.push('/print');
},


        pointName() {
            for (let col of this.meta.columns){
             //       console.log(col);
                    if  (col.widget.name === 'point') {
                        this.pointfieldname = col.fieldname;
                }
            }
        },

        resetFilters(){
          this.filters = {};
          this.getMeta();
        },

        getMeta(){
            axios.get(this.tablestructur).then((response) => {
//                console.log(response);
                this.meta= JSON.parse(response.data.aaData[0].JSON);

                this.allmeta = JSON.parse(response.data.aaData[0].JSON); // для формы правки - там могут быть поля которые исключены из визибла
//console.log('allmeta',this.allmeta);
this.$store.commit('getMetaPrint', this.allmeta);
//this.$store.commit('getColumnPrint', this.allmeta.columns);
                this.meta.columns=this.meta.columns.filter(col=> {return col.visible});
                this.pointName();
                this.dnaButtons();
                this.getData();

 //               this.getAllData(); 

//                this.updateMap();
                this.meta.columns.forEach(column => {

//                  console.log(this.filters[column.fieldname]);
if (this.filters[column.fieldname]==undefined){
  this.filters[column.fieldname]=[];
}
// else{
//   this.filters[column.fieldname]=this.filters[column.fieldname];
// }       
// строки вверху должны сохранять фильтрацию при правке строк, но это кривой код - его надо исправить
// this.filters[column.fieldname]=[];

                    this.sorts[column.fieldname]='';
                    this.groupings[column.fieldname]='';

                });
            });



        },

        dnaButtons(){
        //  console.log(this.meta.description);
          if (this.meta.dataset_id == 241 || this.meta.dataset_id == 263 || this.meta.dataset_id == 245 || this.meta.dataset_id == 71) { 
            this.addeditclone = true;
          }
          else if (this.meta.description.includes('_species_')){
            this.addeditclone = true;
          }
          else{
            this.addeditclone = false;
          }
        },

getLastRowData(){
  //  console.log(this.sorts);
  this.lastrowdot = true;
  this.meta.columns.forEach(column => {
  this.sorts[column.fieldname]='';
  });
  //  console.log(this.sorts);
  this.page=1;
},



        getData(){

            let querydata = {sort: []};

            Object.keys(this.filters).forEach(key => {
          //  console.log(key, this.filters[key]);
            querydata['f_'+key] = this.filters[key];

if(this.filters[key].length > 0 && this.meta.description.includes('_print')){
  this.printfiltered=true;
}

            if (key in this.sorts && this.sorts[key] != '') {
              querydata.sort.push({fieldname:key, dir: this.sorts[key]});
//              console.log(querydata);
            }
            //
            if (this.groupingswitch == true) {
              querydata['g_'+key]='count'; // fieldname or key?

              if (key in this.groupings && this.groupings[key] != '') {
                querydata['g_'+key] = this.groupings[key];
              }
              else{
                querydata['g_'+key]='';
              }
            }
            });
  //          console.log(this.page);

//this.updateMap();

            axios
          //  .post(this.dataset_uri+'&unique=undefined&count_rows=true&iDisplayStart='+(this.page-1)*this.perPage+'&iDisplayLength='+this.perPage, querydata)
            .post(this.dataset_uri+'&unique=undefined&count_rows=true&iDisplayStart='+(this.page-1)*this.perPage+'&iDisplayLength='+this.perPage, querydata)
            
            .then((response) => {
// &unique=undefined&count_rows=true& - что это?
            this.rows=response.data.aaData;

            this.pagecount=Math.max(1,Math.trunc(response.data.iTotalRecords / this.perPage)+1);
          //  this.pagecount=response.data.iTotalRecords;
            this.rowscount = response.data.iTotalRecords;

//           console.log(this.lastrowdot,this.rows[0]);
            if(this.lastrowdot==true){
              this.lastrowd = this.rows[0];
            }
          })
          .catch(error => console.log(error));

this.updateMap();
//исключить обновление карты если прозошел переход на след страницу
        },

    
        

getExportData(){


 let querydata = '';

//          this.sorts.id = true; // sample
//        let querydata = {sort: [{fieldname: "species", dir: true}]};

          Object.keys(this.filters).forEach(key => {
        //  console.log(key, this.filters[key]);
          querydata+='&f_'+key+'='+ this.filters[key];
          if (this.groupingswitch == true) {
            if (key in this.groupings && this.groupings[key] != '') {
              querydata+='&g_'+key+'='+ this.groupings[key];
            }
          }
          });

  window.location.href = this.dataset_uri+querydata+'&to_file=true&format=csv';


 // window.location.href = "google.com";
},

        //формирование урла с мапсервера для карты на основе данных таблицы

        updateMap(){
          //           console.log(this.meta.columns[6]);
 //let color = "'regular'";
            let randomString = Math.random().toString(36).slice(2);
            let dataquery = {

            f: encodeURI(this.meta.dataset_id),
                unique: randomString+'coordinates',
            fieldname: this.pointfieldname,

                // mapstyle - сейчас заглушка. Надо будет сделать так, чтобы оно формировало разный стиль для разных даных
                mapstyle: 'TYPE point CLASS NAME "testclass" STYLE SYMBOL "circle" COLOR 3 169 244 SIZE 10 OFFSET 0 0 OPACITY 100 END LABEL COLOR 0 0 0 FONT "verdana" TYPE truetype SIZE 7 ANGLE 0 POSITION AUTO PARTIALS FALSE END END',
                //199 129 196 
                selected_array: [] };

                Object.keys(this.filters).forEach(key => {
// console.log(key, this.filters[key]);
                dataquery['f_'+key] = this.filters[key]; //здесь меняется только свойство объекта
                });

//console.log(dataquery);
            axios
                .post(this.$store.state.mainurl+"/map/createmap", dataquery)
                .then((response) => {

//    console.log(response.data);

                this.url= response.data;

                })
                .catch(error => console.log(error));
        },

        paginate(newpage) {
            this.page=newpage;
            this.lastrowdot = false;
            this.curentRow ={};
            this.getData();
        },

        perpageupdate(perpageitems){
            this.perPage=perpageitems;
            this.getData();

        },

        setcurentRow(getrow) {
            this.curentRow = getrow;
        },
        changeSort(fieldname){
          this.lastrowdot=false;
          this.curentRow ={};
            if (this.sorts[fieldname] == undefined) {
              this.sorts[fieldname] = false;
            }
            else if (this.sorts[fieldname]){
              this.sorts[fieldname] = undefined;
            }
            else {
              this.sorts[fieldname] = true;
            }
            this.getData();
        },


        changeGrouping(fieldname){
            this.lastrowdot=false;
            if (this.groupings[fieldname] == '') {
              this.groupings[fieldname] = "groupby";
            }
            else if (this.groupings[fieldname] == 'groupby') {
              this.groupings[fieldname] = '';
            }
      
            this.getData();
        },

        clicktooltipMessage(){
          if (this.clicktooltip =='Click to copy') {
          this.clicktooltip = 'Copied';
          }
          else {
            this.clicktooltip = 'Click to copy';
          }
          setTimeout(() => {
        this.clicktooltip = 'Click to copy';
      }, 500);

        },

          updateData(updatetype){
            let selfvue = this;  
            let url = '';
              if(updatetype == 'edit'){
                url = this.$store.state.mainurl+"/dataset/update?f=";
              }
              else if (updatetype == 'delete') {
                url = this.$store.state.mainurl+"/dataset/delete?f=";
              }
              else if (updatetype == 'clone'){
                url = this.$store.state.mainurl+"/dataset/add?f=";
              }
              else if (updatetype == 'add'){
                url = this.$store.state.mainurl+"/dataset/add?f=";
              }
              else {
                console.log(updatetype, "error");
              }
            let updaterow = {"document":{}};
            updaterow.document['dataset_id'] = this.meta.dataset_id;
                                                 //              updaterow.document['columns'] = []; // что это - что оно делает?
            this.allmeta.columns.forEach(column => {
              if (updaterow.document[column.fieldname] == '' && column.default_value !='') {
                updaterow.document[column.fieldname] = column.default_value;
              }
// как получить NULL?
              else {
                updaterow.document[column.fieldname] = this.curentRow[column.fieldname];
                if (updaterow.document[column.fieldname] == null){
                  updaterow.document[column.fieldname] = "NULL";
                }
              }
            });
            updaterow.document['f_id'] = this.curentRow.id; // !!!!!!!: this теряется внутри модуля
            let meta = this.allmeta;
            fieldcalc.calculatefields(meta, updaterow.document, 'form', undefined, function(error, chdoc){
              axios
              .post(url+updaterow.document.dataset_id, {document:chdoc})
              .then((response) => {
            //  this.rows=response.data.aaData;
                selfvue.getData();
              })
              .catch(error => console.log(error));
            });

//             setTimeout(() => {
//                 // this.lastrow = updaterow.document;
//                 // this.lastrowdot = true;
// // this.lastrowdot = true;
// // this.lastrowd = this.rows[0];
//console.log(this.curentRow.id);
  this.curentRow.id = '';

//             }, 1000); // 1 second

        },


initRow(action){ 
//updaterow.document['columns'] = []; // что это - что оно делает?

if(action == 'add'){

  let updaterow = {"document":{}};
  updaterow.document['dataset_id'] = this.allmeta.dataset_id;
  this.allmeta.columns.forEach(column => {
    updaterow.document[column.fieldname] = column.init_value;
  });
  this.curentRow = updaterow.document;
  this.curentRow.id = '';
} 
if(action == 'clone'){
let updaterow = {"document":{}};

    this.allmeta.columns.forEach(column => {
      if (column.copy_value == 'empty' || updaterow.document[column.fieldname] == ''){
        updaterow.document[column.fieldname] = column.init_value;
      }  
      else {updaterow.document[column.fieldname] = this.curentRow[column.fieldname]}
    });
    this.curentRow = updaterow.document;
  }

},

  

    },
    




watch: {
// curentRow(newValue) {
// console.log(newValue) 
// },



}, // это можно использовать для операций с выделенной строкой


})
</script>